import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAxiosInstance } from "../../services/Interceptor";
import { useEffect, useState } from "react";
import {
  resetPassword,
  verifyResetPassword,
} from "../../services/ContactPublicService";
import LoadingSpinner from "../../components/LoadingSpinner";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ResetPassword() {
  const { register, handleSubmit, setError } = useForm();
  const apiInstance = useAxiosInstance();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState(undefined);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const url = window.location.href;
    const urlParams = new URLSearchParams(new URL(url).search);
    const accessCode = urlParams.get("AccessCode");
    const email = urlParams.get("email");
    setData({
      accessCode,
      email,
    });
  }, []);

  useEffect(() => {
    const verifyLink = async () => {
      try {
        await verifyResetPassword(apiInstance, data.accessCode, data.email);
      } catch (err) {
        alert("Invalid or expired link.");
        navigate("/sign-in");
      } finally {
        setLoading(false);
      }
    };
    if (data !== undefined) {
      setLoading(true);
      verifyLink();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleResetPassword = async (formData) => {
    if (formData.password !== formData.confirmPassword) {
      setError("confirmPassword", { message: "Passwords do not match." });
      return;
    }

    try {
      await resetPassword(
        apiInstance,
        data.accessCode,
        data.email,
        formData.password,
      );
      alert("Password has been reset successfully.");
      window.location.href = "/sign-in";
    } catch (err) {
      setError("password", { message: "Failed to reset password." });
    }
  };

  return loading ? (
    <div className="mt-10">
      <LoadingSpinner />
    </div>
  ) : (
    <div className="flex items-center justify-center min-h-screen hero-bg">
      <div className="bg-gray-900 bg-opacity-60 p-6 rounded-lg shadow-lg w-full max-w-xl">
        <h2 className="text-white block text-2xl mb-4 text-center">
          Reset Password
        </h2>
        <form onSubmit={handleSubmit(handleResetPassword)}>
          <div className="form-field mt-4">
            <label htmlFor="password">New Password</label>
            <div className="relative flex items-center">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                {...register("password", { required: true })}
                placeholder="Enter new password..."
                className="w-full pr-10 border rounded px-3 py-2"
              />

              <FontAwesomeIcon
                icon={showPassword ? faEyeSlash : faEye}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-600"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          </div>
          <div className="form-field mt-4">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <div className="relative flex items-center">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                {...register("confirmPassword", { required: true })}
                placeholder="Confirm new password..."
                className="w-full pr-10 border rounded px-3 py-2"
              />
              <FontAwesomeIcon
                icon={showConfirmPassword ? faEyeSlash : faEye}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-600"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              />
            </div>
          </div>
          <button
            type="submit"
            className="bg-red-500 mt-4 text-white rounded px-4 py-2"
          >
            Reset
          </button>
        </form>
      </div>
    </div>
  );
}
